export const DIFF_TEXT_COLORS = {
    added: 'text-diff-added',
    deleted: 'text-diff-deleted',
    modified: 'text-diff-modified',
};

export const DIFF_BACKGROUND_COLORS = {
    added: 'bg-diff-added',
    deleted: 'bg-diff-deleted',
    modified: 'bg-diff-modified',
};
